import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { StatusCodeStats } from "@/types/stats";

interface StatusCodeChartProps {
  distribution: StatusCodeStats[];
}

export const StatusCodeChart: React.FC<StatusCodeChartProps> = ({ distribution }) => {
  const data = distribution.map((item) => ({
    code: item.status_code?.toString() ?? "Error",
    count: item.count,
  }));

  const barColor = (code: string) => {
    if (code.startsWith("2")) return "#10b981";
    if (code.startsWith("3")) return "#f59e0b";
    return "#ef4444";
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h3 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">
        Status Code Distribution
      </h3>
      <div className="min-h-[240px]">
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="code" tick={{ fill: "#64748b", fontSize: 12 }} />
            <YAxis tick={{ fill: "#64748b", fontSize: 12 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "0.75rem",
              }}
              labelStyle={{ color: "#0f172a" }}
              itemStyle={{ color: "#0f172a" }}
            />
            <Bar dataKey="count" name="Runs" radius={[4, 4, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={barColor(entry.code)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
